import script from "./understanding-soft-commodity-key-differentiators-between-soft-hard-commodities.vue?vue&type=script&setup=true&lang=js"
export * from "./understanding-soft-commodity-key-differentiators-between-soft-hard-commodities.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__